import { render, staticRenderFns } from "./ProjectDocumentsDropdown.vue?vue&type=template&id=8a830d86&scoped=true"
import script from "./ProjectDocumentsDropdown.vue?vue&type=script&lang=js"
export * from "./ProjectDocumentsDropdown.vue?vue&type=script&lang=js"
import style0 from "./ProjectDocumentsDropdown.vue?vue&type=style&index=0&id=8a830d86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a830d86",
  null
  
)

export default component.exports